module.exports = __webpack_public_path__ + "3f674f6ff4ad14bbfb00eaefafd6d82e.jpg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/labels/headers/stones-throw.jpg
 ** module id = 429
 ** module chunks = 0
 **/